/* istanbul ignore file */
import { createComponentDefinitionForHTML } from '@goto/shell-utils'

const lifecycles = createComponentDefinitionForHTML({
  template: () => `<goto-schedule-settings></goto-schedule-settings>`,
})

export default lifecycles
